import { render, staticRenderFns } from "./SpeedCurveSettingsDialog.vue?vue&type=template&id=34b5b814&scoped=true"
import script from "./SpeedCurveSettingsDialog.vue?vue&type=script&lang=js"
export * from "./SpeedCurveSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./SpeedCurveSettingsDialog.vue?vue&type=style&index=0&id=34b5b814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b5b814",
  null
  
)

export default component.exports